import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import { Link } from "react-router-dom";
import UpdateThank from "./UpdateThank";

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewThank = () => {
  const [thanks, setThanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingThank, setEditingThank] = useState(null);
  const [formData, setFormData] = useState({
    topBar: "",
    headline: "",
    subHeadline: "",
    slug: "",
    image: "",
    video: "",
    showImage: "",
    ticketText: "",
    webinarHeadline: "",
    webinarStartsIn: "",
    webinarStartsText: "",
    webinarButtonText: "",
    redirectPage: "",
  });

  // Fetch thanks from API
  useEffect(() => {
    const fetchThanks = async () => {
      try {
        const response = await axios.get(`${apiUrl}/thanks`);
        setThanks(response.data.thanks);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching thanks:", err);
        setError("Failed to load thanks.");
        setLoading(false);
      }
    };

    fetchThanks();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      try {
        await axios.delete(`${apiUrl}/thanksdelete/${id}`);
        setThanks((prev) => prev.filter((thank) => thank.id !== id));
      } catch (err) {
        console.error("Error deleting entry:", err);
        setError("Failed to delete entry.");
      }
    }
  };

  // Handle Edit Button Click
  const handleEditClick = (thank) => {
    setEditingThank(thank.id);
    setFormData({
      topBar: thank.topBar,
      headline: thank.headline,
      subHeadline: thank.subHeadline,
      slug: thank.slug,
      image: thank.image,
      video: thank.video,
      showImage: thank.showImage,
      ticketText: thank.ticketText,
      webinarHeadline: thank.webinarHeadline,
      webinarStartsIn: thank.webinarStartsIn,
      webinarStartsText: thank.webinarStartsText,
      webinarButtonText: thank.webinarButtonText,
      redirectPage: thank.redirectPage,
    });
  };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
  
    if (type === "checkbox") {
      // For checkboxes, use `checked` instead of `value`
      setFormData((prev) => ({
        ...prev,
        [name]: checked,  // Set the value as true/false based on checked
      }));
    } else if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  


  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      steps: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };


  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Form validation
    if (!editingThank) {
      setError("No entry selected for editing.");
      return;
    }
  
    if (!formData.headline || !formData.video) {
      setError("Headline and Video are required fields.");
      return;
    }
  
    const data = new FormData();
    data.append("_method", "PUT");

    // প্রতিটি ফিল্ড আলাদাভাবে অ্যাপেন্ড করুন
    data.append("topBar", formData.topBar || "");
    data.append("headline", formData.headline || "");
    data.append("subHeadline", formData.subHeadline || "");
    data.append("slug", formData.slug || "");
    
    // ইমেজ ফিল্ড বিশেষ হ্যান্ডলিং
    if (formData.image instanceof File) {
      data.append("image", formData.image);
    } else if (formData.image === null) {
      data.append("image", ""); // ইমেজ রিমুভ করার জন্য
    } else if (typeof formData.image === 'string') {
      // পুরানো ইমেজ অপরিবর্তিত রাখতে কিছু অ্যাপেন্ড করবেন না
    }

    data.append("video", formData.video || "");
    data.append("showImage", formData.showImage ? "1" : "0");

    data.append("ticketText", formData.ticketText || "");
    data.append("webinarHeadline", formData.webinarHeadline || "");
    data.append("webinarStartsIn", formData.webinarStartsIn || "");
    data.append("webinarStartsText", formData.webinarStartsText || "");

    data.append("webinarButtonText", formData.webinarButtonText || "");
    data.append("redirectPage", formData.redirectPage || "");
  
    try {
      await axios.post(`${apiUrl}/thanksupdate/${editingThank}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      alert("Entry updated successfully");
  
      setThanks((prev) =>
        prev.map((thank) =>
          thank.id === editingThank ? { ...thank, ...formData } : thank
        )
      );
      setEditingThank(null); // Clear editing state
      setFormData({}); // Reset formData after successful submission
    } catch (err) {
      console.error("Error updating entry:", err);
      setError("Failed to update entry.");
    }
  };
  

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Thank Pages List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Video</th>
            <th className="border border-gray-300 px-4 py-2">Headline</th>
            <th className="border border-gray-300 px-4 py-2">Sub Headline</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {thanks.map((thank) => (
            <tr key={thank.id}>
              <td className="border border-gray-300 px-4 py-2">
                {thank.video}
              </td>
              <td className="border border-gray-300 px-4 py-2">{thank.headline}</td>
              <td className="border border-gray-300 px-4 py-2">
                {thank.subHeadline}
              </td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(thank)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(thank.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
                
                <Link to={`/thankyou/${thank.slug}`} className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2">View</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingThank && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateThank
              formData={formData}
              handleQuillChange={handleQuillChange}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              loading={loading}
              error={error}
              onCancel={() => setEditingThank(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewThank;
